import React, { Component } from 'react';


class DescriptionContainer extends Component {
    render() {
        return (
            <div id="description" className="animated shake">I’m a
                    <span className="text-highlight-primary">{this.props.primaryTitle}</span> and
                    <span className="text-highlight-secondary">{this.props.secondaryTitle}</span>.
            </div>
        );
    }
}

export default DescriptionContainer;



// WEBPACK FOOTER //
// ./src/components/hello/description.component.jsx